'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"],
  _excluded2 = ["tablePixelWidth"];
import tinymce from 'tinymce';
import DimensionControlGroup from 'rich-text-lib/components/toolbar/DimensionControlGroup';
import { pick } from 'rich-text-lib/utils/iterables';
import { CANVAS_DIMENSIONS } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualDimensionControls(editor) {
  const handleDimensionChange = (contextualNodeAttributes, dimensions, dimensionType) => {
    const target = editor.selection.getNode();
    editor.fire('hsDimensionChange', {
      target,
      dimensions,
      dimensionType,
      contextualNodeAttributes
    });
  };
  const dimensionAttributes = ['dimensions', 'maxDimensions', 'tablePixelWidth', 'naturalWidth', 'naturalHeight', 'showDimensionsControls', 'dimensionsDisabledTooltip', 'allowUnitDimensions', 'lockedAspectRatio', 'activeElement'];
  tinymce.canvas.addButton(editor, CANVAS_DIMENSIONS, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const dimensionContextualProps = pick(dimensionAttributes, contextualNodeAttributes);
      const {
          tablePixelWidth: pixelWidth
        } = dimensionContextualProps,
        restContextualProps = _objectWithoutPropertiesLoose(dimensionContextualProps, _excluded2);
      return /*#__PURE__*/_jsx(DimensionControlGroup, Object.assign({}, rest, restContextualProps, {
        pixelWidth: pixelWidth,
        onDimensionChange: handleDimensionChange.bind(null, contextualNodeAttributes)
      }));
    }
  });
}